import {useMutation} from 'react-query';
import PatchActivateStore from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IPatchActivateStoreProps {
  onSuccess?: () => void;
  guid?: string;
}

const usePatchActivateStore = ({onSuccess}: IPatchActivateStoreProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IActivateStoresProps) => {
      return PatchActivateStore(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePatchActivateStore};
